export const AD_MANAGER_READY = 'adManagerReady';
export const HEADER_BIDDER_TIMEOUT = 'headerBidderTimeout';
